import React, { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import ContractsModal from '../../components/ContractsModal'
import Dialog from '../../components/Dialog'
import Loading from '../../components/Loading'
import RowsTableExtratos from '../../components/RowsTableExtratos'
import api, { operation } from '../../services/axios'
import { StoreState } from '../../store'
import { cnpjCpfMask, parseDate } from '../../utils/masks'
import { ContratoProtocol, GarantiasContratoCsv } from '../Extratos/interfaces'
import {
    Container,
    RecurrenceData,
    RecurrenceContracts,
    Header,
    ContractsTable,
} from './styles'
import { frequenciaCobranca } from '../../utils/frequenciaCobranca'
import { get } from 'lodash'
import swal from 'sweetalert'

import { useBancos } from '../../hooks/bancos'
import dayjs from '../../libs/dayjs'

const RecorrenciaIndividual: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const { id } = useParams()
    const { bancos } = useBancos()
    const navigate = useNavigate()
    const [recurrence, setRecurrence] = useState({} as any)
    const [contracts, setContracts] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [contractSelected, setContractSelected] = useState(
        {} as ContratoProtocol
    )
    const [contractsExport, setContractsExport] = useState<
        GarantiasContratoCsv[]
    >([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    // precisa tratar o acesso do usuario e se esse id é valido

    const getRecurrence = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const { data } = await api.get(`/recorrencia/${cnpj_cpf}/${id}`)
                setRecurrence(data.recurrence)
                setContracts(data.contracts)
                const res = await api.get(
                    `/recorrencia/garantias/${cnpj_cpf}/${id}`
                )
                setContractsExport(res.data)
                setIsLoading(false)
            } catch (error: any) {
                setIsLoading(false)
                const status = get(error, 'response.status', '')
                if (status === 403 || status === 400) {
                    swal({
                        title: 'Erro ao buscar recorrência',
                        text: `Você não tem acesso a esta recorrência ou ela não existe mais.`,
                        icon: 'error',
                    })
                    navigate('/recorrencia/gerenciar')
                }

                if (status === 401) {
                    if (operation.retry(error)) return
                }
            }
        })
    }, [cnpj_cpf, id, navigate])

    useEffect(() => {
        getRecurrence()
    }, [getRecurrence])

    // const dataCsv = contractsExport?.map((garantia) => {
    //     const banco = bancos[garantia.DP_compe]
    //     const credenciadora =
    //         credenciadoras[
    //             garantia.contrato.credenciadora as keyof typeof credenciadoras
    //         ]
    //     const bandeira =
    //         arranjosPrincipais[
    //             garantia.DefUR_listaCodigoArranjoPagamento as keyof typeof arranjosPrincipais
    //         ]
    //     return {
    //         RefExtContrato: garantia.contrato.referenciaExterna,
    //         protocolo: garantia.contrato?.contratoRetorno?.protocolo,
    //         tipoContrato: garantia.contrato.tipoContrato,
    //         dataAssinatura: garantia.contrato?.dataAssinatura,
    //         crendeciadora: credenciadora,
    //         cnpjParticipante: garantia.contrato?.cnpjParticipante,
    //         tipoServico: garantia.contrato?.statusContrato,
    //         tipoEfeito: garantia.contrato?.tipoEfeito,
    //         modalidadeOp: garantia.contrato?.modalidadeOperacao,
    //         canal: garantia.contrato?.canal,
    //         cnpjPagador: garantia.contrato?.cnpjPagador,
    //         pagador: garantia.contrato?.nomePagador,
    //         cnpjRecebedor: garantia.contrato?.cnpjRecebedor,
    //         recebedor: garantia.contrato?.nomeRecebedor,
    //         banco: banco,
    //         compe: garantia.DP_compe,
    //         ispb: garantia.DP_ispb,
    //         agencia: garantia.DP_agencia,
    //         conta: garantia.DP_numeroConta,
    //         tipoConta: garantia.DP_tipoConta,
    //         DataVencimentoUR: garantia.DefUR_dataFim,
    //         bandeira: bandeira,
    //         valorUR: garantia.valorAOnerar,
    //         valorTotalContrato: garantia.contrato?.saldoDevedor,
    //         situacao: !garantia.contrato?.visibilidade
    //             ? 'Pendente de confirmação da registradora'
    //             : garantia.contrato?.situacao,
    //         obs: garantia.contrato?.observacao,
    //     }
    // })

    // const exportFile = useCallback(() => {
    //     const dataXlsx = contractsExport?.map((garantia) => {
    //         const banco = bancos[garantia.DP_compe]
    //         const credenciadora =
    //             credenciadoras[
    //                 garantia.contrato
    //                     .credenciadora as keyof typeof credenciadoras
    //             ]
    //         const bandeira =
    //             arranjosPrincipais[
    //                 garantia.DefUR_listaCodigoArranjoPagamento as keyof typeof arranjosPrincipais
    //             ]
    //         return {
    //             'Referência externa': garantia.contrato.referenciaExterna,
    //             Protocolo: garantia.contrato.contratoRetorno?.protocolo,
    //             'Tipo do contrato': garantia.contrato?.tipoContrato,
    //             'Data de assinatura': garantia.contrato?.dataAssinatura,
    //             Crendeciadora: credenciadora,
    //             'Cnpj do participante': garantia.contrato?.cnpjParticipante,
    //             'Tipo de servico': garantia.contrato?.statusContrato,
    //             'Tipo do efeito': garantia.contrato?.tipoEfeito,
    //             'Modalidade de operação': garantia.contrato?.modalidadeOperacao,
    //             Canal: garantia.contrato?.canal,
    //             'Cnpj do pagador': garantia.contrato?.cnpjPagador,
    //             Pagador: garantia.contrato?.nomePagador,
    //             'Cnpj do recebedor': garantia.contrato?.cnpjRecebedor,
    //             Recebedor: garantia.contrato?.nomeRecebedor,
    //             Banco: banco,
    //             Compe: garantia.DP_compe,
    //             Ispb: garantia.DP_ispb,
    //             Agência: garantia.DP_agencia,
    //             Conta: garantia.DP_numeroConta,
    //             'Tipo de conta': garantia.DP_tipoConta,
    //             'Data de vencimento da UR': garantia.DefUR_dataFim,
    //             Bandeira: bandeira,
    //             'Valor da UR': garantia.valorAOnerar,
    //             'Valor total do contrato': garantia.contrato?.saldoDevedor,
    //             'Situação do contrato': !garantia.contrato?.visibilidade
    //                 ? 'Pendente de confirmação da registradora'
    //                 : garantia.contrato?.situacao,
    //             Observação: garantia.contrato?.observacao,
    //         }
    //     })
    //     const ws = utils.json_to_sheet(dataXlsx)
    //     const wb = utils.book_new()
    //     utils.book_append_sheet(wb, ws, 'Data')
    //     writeFileXLSX(wb, 'Recorrencia.xlsx')
    // }, [contractsExport, bancos])

    // const valorTotalContracts = contracts.reduce(
    //     (sum: number, contrato: ContratoProtocol) =>
    //         sum + Number(contrato.saldoDevedor),
    //     0
    // )

    function handleSelectContract(contract: ContratoProtocol) {
        setContractSelected(contract)
        setIsModalOpen(true)
    }

    function renderContractRows() {
        return contracts.map((contract: ContratoProtocol) => {
            return (
                <RowsTableExtratos
                    key={contract.id}
                    contract={contract}
                    handleSelectContract={handleSelectContract}
                />
            )
        })
    }
    return (
        <Container>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    {/* <RecurrenceData>
                        <div className="contrato">
                            <div className="group">
                                <div className="wrapper">
                                    <p><span>Data de criação: </span> {dayjs(recurrence?.createdAt).format('DD/MM/YYYY HH:mm:ss')}</p>
                                    <p><span>Idenficação: </span> {recurrence?.id}</p>
                                </div>
                            </div>
                            <div className="group">
                                <div className="wrapper">
                                    <p><span>Próxima liquidação: </span> {parseDate(recurrence?.data_liquidacao_atual || '', true)}</p>
                                    <p><span>Tipo de cobrança: </span> {tipoCobranca[recurrence?.tipoCobranca as keyof typeof tipoCobranca || '']}</p>
                                </div>
                            </div>
                            <div className="group">
                                <div className="wrapper">
                                    <p><span>Dia de liquidação: </span>Todo dia {recurrence?.diaUtil} ou próximo dia útil</p>
                                    <p><span>Canal: </span> {recurrence?.canal || ''}</p>
                                </div>
                            </div>
                        </div>

                        <div className="data">
                            <div className="group">
                                <div className="wrapper">
                                    <p><span>Pagador: </span> {recurrence?.nomePagador}</p>
                                    <p><span>CNPJ/CPF: </span> {cnpjCpfMask(recurrence?.cnpjPagador || '')}</p>
                                </div>
                            </div>
                            <div className="group">
                                <div className="wrapper">
                                    <p><span>Recebedor: </span> {recurrence?.nomeTitular}</p>
                                    <p><span>CNPJ/CPF: </span> {cnpjCpfMask(recurrence?.numeroDocumentoTitular || '')}</p>
                                </div>
                                <div className="wrapper">
                                    <p><span>Banco: </span> {bancos[recurrence?.compe]}</p>
                                    <p><span>Agência: </span> {recurrence?.agencia}</p>
                                    <p><span>Conta: </span> {recurrence?.numeroConta}</p>
                                    <p><span>Tipo de conta: </span> {recurrence?.tipoConta}</p>
                                </div>
                                <div className="wrapper">
                                    <p><span>Email: </span> {recurrence?.email}</p>
                                    <p><span>Telefone: </span> {foneMask(recurrence?.telefone || '')}</p>
                                </div>
                            </div>

                            <div className="group">
                                <div className="wrapper">
                                    <p><span>Situação: </span> {recurrence?.situacao}</p>
                                    <p><span>Mensagem: </span> {recurrence?.mensagem || 'n/a'}</p>
                                </div>
                            </div>
                            <div className="group">
                                <div className="wrapper">
                                    <p><span>Valor: </span> {Number(recurrence?.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                </div>
                            </div>
                        </div>
                    </RecurrenceData> */}
                    <RecurrenceData>
                        <div className="input-group">
                            <h3>Valor pago</h3>
                            <div className="wrapper">
                                <p>
                                    {Number(recurrence?.valor).toLocaleString(
                                        'pt-br',
                                        { style: 'currency', currency: 'BRL' }
                                    )}
                                </p>
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="wrapper info">
                                <p>
                                    <strong className="situation">
                                        Situação recorrência:{' '}
                                    </strong>
                                    {recurrence?.situacao}
                                </p>
                                <p>
                                    <strong className="canal">
                                        Dia da liquidação:{' '}
                                    </strong>
                                    Todo dia {recurrence?.diaUtil} ou próximo
                                    dia útil.
                                </p>
                                <p>
                                    <strong className="canal">
                                        Próxima liquidação:{' '}
                                    </strong>{' '}
                                    {parseDate(
                                        recurrence?.data_liquidacao_atual || '',
                                        true
                                    )}
                                </p>
                                <p>
                                    <strong className="canal">
                                        Tipo de cobrança:{' '}
                                    </strong>
                                    {
                                        frequenciaCobranca[
                                            (recurrence?.tipoCobranca as keyof typeof frequenciaCobranca) ||
                                                ''
                                        ]
                                    }
                                </p>
                                {/* <p><strong className='canal'>Duração: </strong>{recurrence.duracao} meses</p> */}
                                <p>
                                    <strong className="op">
                                        Número da operação:{' '}
                                    </strong>
                                    {recurrence?.numeroOperacao}
                                </p>
                                <p>
                                    <strong className="canal">
                                        Canal de origem:{' '}
                                    </strong>
                                    {recurrence?.canal}
                                </p>
                            </div>
                        </div>

                        <div className="input-group">
                            <h3>Dados do recebedor</h3>
                            <div className="receiver">
                                <div className="wrapper">
                                    <strong>Para: </strong>
                                    <p>{recurrence?.nomeTitular}</p>
                                </div>
                                <div className="wrapper">
                                    <p>
                                        <strong>Cpf/Cnpj: </strong>{' '}
                                        {cnpjCpfMask(
                                            recurrence?.numeroDocumentoTitular ||
                                                ''
                                        )}
                                    </p>
                                </div>
                            </div>
                            <h4>Domicílio bancário: </h4>
                            <div className="flex">
                                <div className="wrapper">
                                    <p>Banco: {bancos[recurrence?.compe]}</p>
                                </div>
                                <div className="wrapper">
                                    <p>Agência: {recurrence?.agencia}</p>
                                </div>
                                <div className="wrapper">
                                    <p>
                                        Número da conta:{' '}
                                        {recurrence?.numeroConta}
                                    </p>
                                </div>
                            </div>
                            <div className="wrapper">
                                <p>Tipo de conta: {recurrence?.tipoConta}</p>
                            </div>
                        </div>

                        {/* <h4>Contato: </h4>
                <div className="flex">
                    <div className="wrapper">
                        <p><span>Email: </span>{contract.emailRecebedor}</p>
                    </div>
                    <div className="wrapper">
                        <p><span>Telefone: </span>{foneMask(contract.foneRecebedor)}</p>
                    </div>
                </div> */}

                        <div className="input-group">
                            <h3>Dados do pagador</h3>
                            <div className="wrapper">
                                <strong>De: </strong>
                                <p>{recurrence?.nomePagador}</p>
                            </div>
                            <div className="wrapper">
                                <p>
                                    <strong>Cpf/Cnpj: </strong>
                                    {cnpjCpfMask(recurrence?.cnpjPagador || '')}
                                </p>
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="wrapper details">
                                <p>
                                    Data e hora da criação:{' '}
                                    {dayjs(recurrence?.createdAt).format(
                                        'DD/MM/YYYY - HH:mm:ss'
                                    )}
                                </p>
                                <p>Mensagem: {recurrence?.mensagem || 'n/a'}</p>
                                <p>
                                    Observação:{' '}
                                    {recurrence?.observacao || 'n/a'}
                                </p>
                            </div>
                        </div>
                    </RecurrenceData>
                    <RecurrenceContracts>
                        <Header>
                            <div className="title">
                                <h2>Contratos da recorrência</h2>
                            </div>
                            <div className="exports">
                                {/* <CSVLink data={dataCsv} filename='Recorrencia.csv' headers={headers}>
                                    <button><FiDownload size={18} /> Exportar CSV</button>
                                </CSVLink>
                                <button onClick={exportFile}><FiDownload size={18} /> Exportar XLSX</button> */}
                            </div>
                        </Header>

                        <ContractsTable>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Data</th>
                                    <th>
                                        CNPJ/CPF <br />
                                        (Quem vai receber)
                                    </th>
                                    <th className="recebedor">Recebedor</th>
                                    <th className="adq">Adq</th>
                                    <th className="categoria"></th>
                                    <th>Valor</th>
                                    <th className="tipo">Tipo</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>{renderContractRows()}</tbody>

                            {/* <tfoot>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Total</td>
                                    <td>{valorTotalContracts?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                    <td></td> 
                                </tr>
                            </tfoot> */}
                        </ContractsTable>
                    </RecurrenceContracts>
                </>
            )}
            <Dialog
                isTermsOpen={isModalOpen}
                setIsTermsOpen={setIsModalOpen}
                title="Comprovante de Pagamento"
            >
                <ContractsModal contract={contractSelected} />
            </Dialog>
        </Container>
    )
}

export default RecorrenciaIndividual
